import { Box, Heading, Text, Image,HStack, Flex, SimpleGrid, useColorModeValue } from '@chakra-ui/react';

import vnpic from "../resources/vnpic.png";
import tapic from "../resources/tapic.jpg";
import TechLayout from './TechLayout';
import { useLocation } from "react-router-dom";
import React, {  useEffect } from "react";



import bandpic from "../resources/studentpics/pexels-pixabay-207756.jpg";



const AboutTechPage = () => {

  const bandcolor = useColorModeValue("gray.100", "gray.700");

   const { hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        const yOffset = -80; // same offset you use on Coaching
        const yPosition = el.getBoundingClientRect().top + window.scrollY + yOffset;
        window.scrollTo({ top: yPosition, behavior: "smooth" });
      }
    }
  }, [hash]); 

  return (

<TechLayout>
    <Box bg="black" color="white">
        <Box as="section" id="about" maxW="1200px" mx="auto" px={5} py={10}>
        {/* About Us */}
        <Heading size="lg" mb={6} textAlign="center">
            About Us
        </Heading>
        <Text fontSize="sm" color="gray.300" mb={6} textAlign="justify" lineHeight="taller">
            Eduvic is a Melbourne-based education technology business, founded in
            mid-2024. We build the platform, content, and assessment experience that
            sits behind structured learning and exam preparation — staying close to
            the problems we're solving rather than chasing every direction at once.
            <br /><br />
            Our first product, the <strong>Eduvic Learning Platform</strong>, launched
            in October 2025. That same assessment foundation now also powers the{" "}
            <strong>Eduvic Practice Platform</strong>, our direct-to-student product
            for exam-realistic practice and assessment, with Eduvic Coaching running
            on the platform as our own first customer.
        </Text>

        {/* Leadership Section */}
        <Heading size="md" mb={6} textAlign="center">
            Our Leadership
        </Heading>
        <Box
            maxW="1200px"
            mx="auto"
            p={6}
            bg="gray.800"
            borderRadius="md"
            boxShadow="lg"
            display="flex"
            flexDirection={{ base: "column", md: "row" }}
            alignItems="center"
            textAlign={{ base: "center", md: "left" }}
            gap={6}
        >
            {/* Leader's Image */}
            <Box
            flexShrink={0}
            w="250px"
            h="250px"
            borderRadius="full"
            overflow="hidden"
            boxShadow="md"
            >
            <Image
                src={vnpic} // Replace with actual image URL
                alt="Vikrant Nath"
                objectFit="cover"
                w="100%"
                h="100%"
            />
            </Box>

            {/* Leader's Information */}
            <Box flex="1">
            <Heading size="md" mb={2}>
                Vikrant Nath
            </Heading>
            <Text fontSize="sm" color="gray.400" mb={4}>
                Founder, Eduvic Technologies
            </Text>
            <Text fontSize="sm" color="gray.300" lineHeight="taller" textAlign="justify">
                Vikrant Nath brings over two decades of experience in the technology
                sector, beginning his career as a Software Engineer and going on to
                hold roles including Assistant Vice President and Associate Director.
                He has led technology functions including New Technology CoE Leader
                at Genpact and Head of Cloud Engineering Services for corporate
                accounts at Persistent Systems (MediaAgility), working with
                organisations such as Nagarro, Fidelity, Sapient, and Infosys on
                projects for clients including GE Healthcare, Lufthansa Cargo, and
                Morgan Stanley.
                <br /><br />
                At Eduvic, Vikrant is the lead technologist behind the platform —
                working across systems design, architecture, and development, as well
                as shaping the product from a business standpoint, to bring the
                Learning and Practice Platforms from concept to production.
                <br /><br />
                He holds a Bachelor of Engineering degree in Computer Science with
                Honours.
            </Text>
            </Box>
        </Box>
        </Box>
</Box>
</TechLayout>
  );
};

export default AboutTechPage;
